var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagoutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7 3.4C1.7 2.46 2.46 1.7 3.4 1.7H9.1C9.55 1.7 9.98 1.88 10.3 2.2L17.8 9.7C18.46 10.36 18.46 11.44 17.8 12.1L12.1 17.8C11.44 18.46 10.36 18.46 9.7 17.8L2.2 10.3C1.88 9.98 1.7 9.55 1.7 9.1V3.4Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1.5,
    stroke: "#4A4A4A",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagoutline);
export default __webpack_public_path__ + "static/media/tag.outline.40bca05ab4dabae2dc0b50479b79b36a.svg";
export { ForwardRef as ReactComponent };